module.exports = __webpack_public_path__ + "static/media/tdoa_tracker_sel.7431a86c.svg";